import { jsx as _jsx } from "react/jsx-runtime";
import SuccessTaskMessage from '@/spectrum/components/SuccessTaskMessage/SuccessTaskMessage';
export function generateSuccessMessage(page, model) {
    return _jsx(SuccessTaskMessage, { page: page, spectrumProduct: model });
}
